import React from 'react';

import { Root, Indicator } from '@radix-ui/react-checkbox';
import IconTick from '$partials/icons/icon-tick';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/fields.d.ts').Checkbox}
 */
export const Checkbox = ({
    checked,
    id,
    name,
    onCheckedChange,
}) => {
    return (
        <Root
            checked={checked}
            className='checkbox__root'
            id={id}
            name={name}
            onCheckedChange={onCheckedChange}>
            <Indicator className='checkbox__indicator'>
                <IconTick />
            </Indicator>
        </Root>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Checkbox;
